{
  "recaptcha_site_key": "6LeUpqwcAAAAAIbPGZBewpl-dRr-Ca7x86v_8Mc0",
  "firebase_api_key": "AIzaSyCiap1CNmRfZ2eNXKMmjEmoYLCc197cUiI",
  "release": "a04d91fe0de24a85eac3ed317247fd0d91c41298"
}
